__turbopack_context__.v({
  "accountButton": "header-module-scss-module__I3Dr5q__accountButton",
  "accountIcon": "header-module-scss-module__I3Dr5q__accountIcon",
  "container": "header-module-scss-module__I3Dr5q__container",
  "headerButtons": "header-module-scss-module__I3Dr5q__headerButtons",
  "headerLogo": "header-module-scss-module__I3Dr5q__headerLogo",
  "logOutButton": "header-module-scss-module__I3Dr5q__logOutButton",
  "logo": "header-module-scss-module__I3Dr5q__logo",
  "logoName": "header-module-scss-module__I3Dr5q__logoName",
  "wrapper": "header-module-scss-module__I3Dr5q__wrapper",
});
